/**
 * Toggle classes
 * @module abControls
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'abControls';


/**
 * Applies any sort of event handlers for the abControls.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el) => {
  const activeClass = 'ab-controls--active';
  $el.find('.js-ab-controls-btn').on('click', () => {
    if ($el.hasClass(activeClass)) {
      $el.removeClass(activeClass);
      $('.ab-controls__wrapper').css('width', 'auto');
    } else {
      $('.ab-controls__wrapper').css('width', '100%');
      $el.addClass(activeClass);
    }
  });
  $(document).on('mouseup.dropdown', (e) => {
    if (!$el.is(e.target) && $el.has(e.target).length === 0) {
      $el.removeClass(activeClass);
    }
  });
  $el.find('.js-ab-controls-close').on('click', (e) => {
    e.stopPropagation();
    $el.removeClass(activeClass);
  });
  $el.find('.js-ab-controls-remove').on('click', (e) => {
    e.preventDefault();
    $el.removeClass('ab-controls--show');
    localStorage.setItem('abControls', 'false');
  });
  $el.find('.ab-controls-clickable').on('click', (e) => {
    const element = $(e.target);
    const request = $.ajax({
      url: '/dbadmin/spring-controller/abtest/toggleABTestGroup',
      type: 'POST',
      data: element.data('value'),
    });

    request.done(() => {
      window.location.reload(true);
    });
  });
};
/**
 * Initializes abControls.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function abControls(el) {
  const $el = $(el);
  $.ajax({
    url: '/dbadmin/spring-controller/abtest/abtest-widget',
    type: 'GET',
    data: { abtestids: $el.data('ids'), device: 'mobile' },
    success: (data) => {
      $el.append(data);
      setEventListeners($el);
      if (localStorage.getItem('abControls') === 'false') {
        $el.removeClass('ab-controls--show');
      } else if (localStorage.getItem('abControls') === 'true' || localStorage.getItem('abControls') === null) {
        $el.addClass('ab-controls--show');
        localStorage.setItem('abControls', 'true');
      }
    },
  });
}
registerJQueryPlugin(PLUGIN_NAME, abControls);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/ab-controls.js